import { ObjectWithProfileName } from "PFCore/helpers/profile";
import { Activity, Id, Profile, Shortlist } from "PFTypes";
import { createContext, useContext } from "react";

export type RoleProfileActionButtonsContextType = {
  role: Activity;
  profile: Pick<Profile, "id"> & ObjectWithProfileName;
  shortlist: Pick<Shortlist, "id" | "state" | "applicableCustomValues"> | null;
  isFillDisabled: boolean;
  areButtonsDisabled?: boolean;
  small?: boolean;
  named?: boolean;
  removeProfileFromComparison?: (id: Id) => void;
};

export const RoleProfileActionButtonsContext = createContext<RoleProfileActionButtonsContextType>(
  {} as RoleProfileActionButtonsContextType
);

export const useRoleProfileActionButtonsContext = () => {
  const context = useContext(RoleProfileActionButtonsContext);

  if (!context) {
    throw new Error(
      "useRoleProfileActionButtonsContext must be used within a RoleProfileActionButtonsContextProvider"
    );
  }

  return context;
};
